export const LEAD_LIST_KEY = 'leads_list';
export const LEAD_LIST_QUERY_KEY = 'leads_list_query';
export const LEAD_DETAILS = 'leads_details';
export const LEAD_STATES = 'lead_states';
export const LEAD_STATE = 'lead_state';
export const LEAD_INSURANCE = 'lead_insurance';
export const LEAD_CONSENT = 'lead_consent';
export const LEAD_HEALTH_ASSESSMENT = 'lead_health_assessment';
export const UNREAD_SMS_LIST = 'unread_sms_list';
export const UNREAD_SMS_COUNT = 'unread_sms_count';
